var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgSpeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_2739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8324 19.222C23.1301 17.4293 23.9065 15.3125 24.0762 13.106C24.2457 10.8994 23.8019 8.68893 22.7937 6.71891C21.7853 4.74888 20.2519 3.09604 18.3629 1.94315C16.4739 0.790242 14.3027 0.182189 12.0897 0.186205C9.87663 0.190222 7.70777 0.806152 5.82292 1.9659C3.93807 3.12565 2.41065 4.78404 1.40952 6.75771C0.408389 8.73139 -0.0274494 10.9435 0.150189 13.1494C0.327827 15.3554 1.11203 17.4691 2.41609 19.2572L3.96734 18.1259C2.87194 16.6238 2.21321 14.8483 2.064 12.9953C1.91477 11.1423 2.28088 9.28416 3.12183 7.62628C3.96279 5.96837 5.24583 4.57533 6.8291 3.60115C8.41237 2.62695 10.2342 2.10957 12.0932 2.1062C13.9521 2.10282 15.7758 2.61359 17.3627 3.58203C18.9495 4.55046 20.2376 5.93884 21.0845 7.59367C21.9314 9.24849 22.3043 11.1053 22.1619 12.9588C22.0193 14.8123 21.367 16.5903 20.2771 18.0962L21.8324 19.222Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31829 11.399L1.81842 11.4185L1.84374 13.3683L3.34362 13.3488L3.31829 11.399Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8166 11.1458L21.3168 11.1653L21.3421 13.1151L22.842 13.0956L22.8166 11.1458Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9852 3.98486L17.9384 5.0592L19.335 6.42004L20.3818 5.3457L18.9852 3.98486Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55007 5.19974L5.47437 4.15161L4.11353 5.54826L5.18924 6.59639L6.55007 5.19974Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2183 1.76922L11.2378 3.271L13.1877 3.24567L13.1682 1.7439L11.2183 1.76922Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3692 14.1322C13.4047 14.1187 14.2332 13.2685 14.2197 12.233C14.2063 11.1976 13.356 10.3691 12.3205 10.3825C11.2851 10.396 10.4566 11.2463 10.47 12.2817C10.4835 13.3171 11.3338 14.1456 12.3692 14.1322Z",
    fill: "#FFA061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0113 6.46839L14.1872 12.268L12.3002 10.4234L18.0113 6.46839Z",
    fill: "#FFA061"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_2739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgSpeed);
export default __webpack_public_path__ + "static/media/avg-speed.d89952e7cf3a520b5be0c22884dab307.svg";
export { ForwardRef as ReactComponent };